import React from 'react';
import { useMountEffect } from 'js/hooks/useMountEffect';

import { logRunTag } from './helpers';

export const withLogger = TagComponent => (props) => {
    const { tagName, tagTypeId, config } = props;

    useMountEffect(() => {
        logRunTag(tagName, tagTypeId, config);
    }, [tagName, tagTypeId, config]);

    return <TagComponent {...props} />;
};
